<template>
  <div class="withdraw_wrap">
    <!-- <div class="base-header">
      <div class="big_tit" @click="$router.push('recharge')">{{ $t('充值') }}</div>
      <div :class="is_active ? 'big_tit is-active' : 'big_tit'">{{ $t('提现') }}</div>
    </div> -->
    <div class="left_div">
      <div class="left" @click="$router.push('/')">
        <svg width="1em" height="1em" fill="" aria-hidden="true" focusable="false">
          <symbol id="comm_icon_fh--svgSprite:all" viewBox="0 0 21.999 35.998">
            <path id="comm_icon_fh--svgSprite:all_comm_icon_fh"
              d="M2209.279,137.564l-17.743-15.773a2.024,2.024,0,0,1-.271-.228,2.009,2.009,0,0,1,0-2.83,2.02,2.02,0,0,1,.274-.23l17.74-15.77a1.992,1.992,0,0,1,2.817,2.816l-16.422,14.6,16.422,14.6a1.992,1.992,0,0,1-2.817,2.817Z"
              transform="translate(-2190.681 -102.15)" />
          </symbol>
          <use xlink:href="#comm_icon_fh--svgSprite:all" />
        </svg>
      </div>
      <van-tabs v-model="active" animated offset-top="1.2rem" lazy-render class="vantTabs" @change="tabChange">
        <van-tab title="Saque" />
        <van-tab title="Registro de Saques" />
      </van-tabs>
    </div>

    <div v-show="active == 0">
      <div class="ablewd">
        <div>
          <div class="left-ab">
            <div class="desc-ab">
              Saldo da Conta
            </div>
            <!-- <img class="jinbi" src="../../assets/images/common/a04.png" /> -->
            <div class="desc-num">
              {{ able_money }}
            </div>
            <div class="wdAble" @click="getWdAble()">
              <svg :class="loading ? 'spin' : ''" width="1.2em" height="1.2em" fill="" aria-hidden="true"
                focusable="false">
                <symbol id="comm_icon_sx--svgSprite:all" viewBox="0 0 24 25.144">
                  <path id="comm_icon_sx--svgSprite:all_comm_icon_sx"
                    d="M1520.314-127.2l5.058-9.146,2.1,3.9a10.844,10.844,0,0,0,4.845-9.038c0-3.028-2-6.031-4-8,3.919,1.639,7.43,5.773,7.43,10.285a10.856,10.856,0,0,1-6.549,9.964l1.977,3.179Zm-8.572-10.858a10.86,10.86,0,0,1,6.548-9.965l-1.976-3.178,10.857,1.142-5.06,9.147-2.095-3.9a10.842,10.842,0,0,0-4.847,9.039c0,3.028,2,6.031,4,8C1515.255-129.409,1511.743-133.543,1511.743-138.055Z"
                    transform="translate(-1511.743 151.198)" />
                </symbol>
                <use xlink:href="#comm_icon_sx--svgSprite:all" />
              </svg>
            </div>
          </div>
          <div class="money_title">
            <span>Você precisa apostar </span>
            <span class="rmoney">R$ {{ need_bet }}</span>
            <span> sacar dinheiro</span>
          </div>
        </div>

        <!-- <div class="right-ab" v-if="need_bet > 0">
          <div class="desc-ab">Ainda precisa apostar</div>
          <div class="desc-num">{{ need_bet }}</div>
        </div> -->
      </div>
      <!-- <div class="ablewd">
        <div class="left-ab">
          <div class="desc-ab">
            {{ $t("可提现金额") }}
          </div>
          <div class="desc-num">
            {{ $t("钱符") }} {{ able_money }}
          </div>
        </div>
        <div
          v-if="need_bet > 0"
          class="right-ab"
        >
          <div class="desc-ab">
            Ainda precisa apostar
          </div>
          <div class="desc-num">
            {{ $t("钱符") }} {{ need_bet }}
          </div>
        </div>
      </div> -->


      <div class="enther">
        <div class="endes">
          {{ $t("请输入您的数量") }} ({{ $t("最低") }}{{ min_withdraw_amount }})
        </div>
        <input v-model="money" type="text" class="amount-input" :placeholder="$t('请输入提现数量')">
        <!-- <div class="fee">{{ $t("提现手续费") }}: {{ withdraw_rate }}%</div> -->
      </div>


      <div class="enther">
        <p class="endes">
          Nome
        </p>
        <input v-model="real_name" type="text" class="amount-input" :placeholder="'Introduza o nome'">
      </div>

      <div class="enther">
        <p class="endes">
          {{ $t("电话号码") }}
        </p>
        <input v-if="!is_withdraled" v-model="phone_number" type="text" class="amount-input"
          :placeholder="$t('请输入电话号码')">
        <input v-if="is_withdraled" v-model="phone_number" type="text" class="amount-input cantc" readonly>
      </div>


      <div class="enther">
        <label for="country" class="endes">Tipo de PIX (CPF / CNPJ / PIX_PHONE)</label>
        <select id="country" v-model="chave_pix" name="country" class="amount-input selectpix">
          <option value="PIX_CPF" :selected="chave_pix == 'PIX_CPF'">
            PIX-CPF
          </option>
          <option value="PIX_CNPJ" :selected="chave_pix == 'PIX_CNPJ'">
            PIX-CNPJ
          </option>
          <option value="PIX_PHONE" :selected="chave_pix == 'PIX_PHONE'">
            PIX_PHONE
          </option>
        </select>
      </div>

      <!-- <div class="enther">
        <p class="endes">Tipo de PIX</p>
        <input type="text"  class="amount-input" :placeholder="$t('Input Pix(CPF)')"
               v-model="chave_pix" readonly/>
      </div> -->

      <div class="enther">
        <p v-show="chave_pix == 'PIX_CPF'" class="endes">
          PIX_CPF
        </p>
        <p v-show="chave_pix == 'PIX_CNPJ'" class="endes">
          PIX_CNPJ
        </p>
        <p v-show="chave_pix == 'PIX_PHONE'" class="endes">
          PIX_PHONE
        </p>
        <input v-if="!is_withdraled" v-model="cpf" type="text" class="amount-input"
          placeholder="Conta CPF / Conta CNPJ / Conta PIX_PHONE">
        <input v-if="is_withdraled" v-model="cpf" type="text" class="amount-input cantc" readonly>
      </div>



      <div class="sbtn" @click="submit">
        {{ $t("提现") }}
      </div>
    </div>
    <div v-show="active == 1">
      <div class="select_items">
        <div class="flex_select">
          <div class="select_item">
            <select id="history" v-model="select_history_time" name="history" @change="selectHistoryimeChange">
              <option value="today" :selected="select_history_time == 'today'">
                Hoje
              </option>
              <option value="yesterday" :selected="select_history_time == 'yesterday'">
                Ontem
              </option>
              <option value="last7" :selected="select_history_time == 'last7'">
                Últimos 7 Dias
              </option>
              <option value="last15" :selected="select_history_time == 'last15'">
                Últimos 15 Dias
              </option>
              <option value="last30" :selected="select_history_time == 'last30'">
                Últimos 30 Dias
              </option>
            </select>
          </div>
        </div>

        <div class="bonus">
          Total de Saques:
          <span style="margin-right: 0.3rem">R$ {{ re_list.total_money }}</span>
        </div>
      </div>
      <div v-for="(item, k) in re_list.list" :key="k" class="recharge-one">
        <div class="order-status">
          <div>Pagamento online</div>
          <div class="mmm">
            {{ item.money }}
          </div>
        </div>
        <div class="order-status">
          <div>{{ item.order_no }}</div>
          <div @click="doCopy(item.order_no)">
            <svg data-v-fa159fb6="" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 26 26"
              fill="none">
              <g data-v-fa159fb6="" clip-path="url(#clip0_2451_66251)">
                <g data-v-fa159fb6="" clip-path="url(#clip1_2451_66251)">
                  <path data-v-fa159fb6=""
                    d="M10.1064 5.85938H20.5844C21.7549 5.8607 22.8771 6.32627 23.7048 7.15396C24.5325 7.98165 24.9981 9.10385 24.9994 10.2744V20.7524C24.9981 21.9229 24.5325 23.0451 23.7048 23.8728C22.8771 24.7005 21.7549 25.1661 20.5844 25.1674H10.1064C8.93588 25.1661 7.81368 24.7005 6.98599 23.8728C6.15831 23.0451 5.69273 21.9229 5.69141 20.7524V10.2744C5.69273 9.10385 6.15831 7.98165 6.98599 7.15396C7.81368 6.32627 8.93588 5.8607 10.1064 5.85938ZM20.5844 22.7164C21.1052 22.7161 21.6046 22.5091 21.9729 22.1408C22.3411 21.7726 22.5481 21.2732 22.5484 20.7524V10.2744C22.5466 9.75461 22.3388 9.25675 21.9708 8.88979C21.6027 8.52282 21.1042 8.31664 20.5844 8.31637H10.1064C9.58768 8.31822 9.09073 8.5251 8.72393 8.8919C8.35713 9.25869 8.15025 9.75565 8.14841 10.2744V20.7524C8.14867 21.2721 8.35485 21.7706 8.72182 22.1387C9.08878 22.5068 9.58664 22.7145 10.1064 22.7164H20.5844Z"
                    fill="currentColor" />
                  <path data-v-fa159fb6=""
                    d="M3.46995 20.87C3.29252 20.8705 3.11713 20.8323 2.95599 20.758C2.79485 20.6837 2.65185 20.5752 2.53695 20.44C1.54592 19.2806 1.00156 17.8053 1.00195 16.28V7.406C1.00381 5.70794 1.67904 4.07993 2.87957 2.87903C4.08009 1.67813 5.70789 1.00238 7.40595 1H16.284C17.1489 0.999689 18.005 1.17472 18.8004 1.51452C19.5959 1.85431 20.3142 2.35183 20.912 2.977C21.1245 3.2141 21.2364 3.52458 21.2241 3.84275C21.2118 4.16092 21.0762 4.46182 20.846 4.68178C20.6157 4.90174 20.309 5.0235 19.9906 5.0213C19.6722 5.0191 19.3671 4.89312 19.14 4.67C18.7721 4.28252 18.3289 3.97433 17.8376 3.76436C17.3463 3.55439 16.8172 3.44708 16.283 3.449H7.40595C6.35726 3.45059 5.35201 3.86809 4.61075 4.60992C3.86949 5.35174 3.45275 6.3573 3.45195 7.406V16.284C3.45168 17.2247 3.78713 18.1346 4.39795 18.85C4.54919 19.0279 4.64647 19.2453 4.67834 19.4767C4.71021 19.708 4.67536 19.9436 4.57787 20.1558C4.48039 20.368 4.32433 20.548 4.12806 20.6745C3.93179 20.801 3.70347 20.8688 3.46995 20.87Z"
                    fill="currentColor" />
                </g>
              </g>
              <defs data-v-fa159fb6="">
                <clipPath id="clip0_2451_66251" data-v-fa159fb6="">
                  <rect data-v-fa159fb6="" width="26" height="26" fill="currentColor" />
                </clipPath>
                <clipPath id="clip1_2451_66251" data-v-fa159fb6="">
                  <rect data-v-fa159fb6="" width="26" height="26" fill="currentColor" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <div v-if="item.remark" class="order-status">
          <div>{{ item.remark }}</div>
        </div>
        <div class="money3">
          <div class="order">
            {{ item.time }}
          </div>
          <div :class="item.status == 1 ? 'status' : 'unpay'">
            <b v-if="item.status == 1">{{ $t("已付款") }}</b>
            <b v-else-if="item.status == 0">Pagando</b>
            <b v-else-if="item.status == 2">Pagamento falhou</b>
          </div>
        </div>
      </div>
    </div>

    <pay-layer ref="payLayer" v-model="show_pay" @inputEnd="handleInputEnd" @close="handleClose"
      @forgetPassword="handleForget" />

    <!-- <ft /> -->
    <!-- <ftNav :active="2" /> -->
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import ft from "../../components/ft.vue"
import ftNav from "../../components/footer_nav/footer_nav"
import payLayer from "vue-pay-layer";

Vue.use(payLayer);
export default {
  name: "Cost",
  components:
  {
    ft,
    ftNav,

  },
  data() {
    return {
      able_money: 0, //可以提现金额
      money: null,
      phone_number: "",
      chave_pix: "PIX_CPF",
      real_name: "",
      cpf: "Loading...",
      min_withdraw_amount: null,
      withdraw_rate: null,
      is_active: true,
      is_withdraled: false,
      pay_password: "",
      show_pay: false,
      need_bet: 0,
      select_history_time: "today",
      re_list: [],
      active: 0,
      loading: false
    };
  },
  created() {

  },
  watch: {
    chave_pix(v) {
      console.log(v);
      if (v == 'PIX_PHONE') {
        this.cpf = "+55"
      } else {
        this.cpf = ""
      }
    }
  },
  mounted() {

    //验证一下有没有设置支付密码
    Fetch("/Withdrow/hasWithdrawPassword").then((res) => {
      console.log(res);
      if (res.data.is_set == 0) {
        this.$router.push("setpasswd");
      } else {
        this.getWdAble();
      }
    });



  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    //获取可以提现的金额
    getWdAble() {
      this.loading = true
      Fetch("/Withdrow/getWithdrawInfo").then((res) => {
        this.able_money = res.data.can_withdraw_amount;
        this.min_withdraw_amount = res.data.min_withdraw_amount;
        this.withdraw_rate = res.data.withdraw_rate;
        this.cpf = res.data.cpf;
        this.real_name = res.data.real_name;
        this.phone_number = res.data.phone_number;
        this.need_bet = res.data.need_bet;
        this.chave_pix = res.data.chave_pix ? res.data.chave_pix : "PIX_CPF";
        this.loading = false
      });
    },
    tabChange(v) {
      this.active = v;
      if (this.active == 1) {
        Fetch("/withdrow/getwithdrawbydate", {
          type: this.select_history_time,
        }).then((r) => {
          if (r.data) {
            this.re_list = r.data;
          }
        });
      }
    },

    selectHistoryimeChange() {
      this.re_list = [];
      Fetch("/withdrow/getwithdrawbydate", {
        type: this.select_history_time,
      }).then((r) => {
        if (r.data) {
          this.re_list = r.data;
        }
      });
    },
    handleInputEnd(pay_password) {
      // if (this.chave_pix == "PIX_PHONE") this.cpf = "+55" + this.cpf;
      Fetch('/Withdrow/addWithdraw', {
        money: this.money,
        phone_number: this.phone_number,
        chave_pix: this.chave_pix,
        cpf: this.cpf,
        email: this.email,
        real_name: this.real_name,
        pay_password: pay_password,
      }).then(res => {
        if (res.code == 1) {
          this.$message({
            title: "R$" + this.money,
            message: this.$t("提现成功"),
            type: 'success'
          });
          setTimeout(() => {
            this.$router.push('/')
          });
        } else {

          setTimeout(() => {
            this.$message.error({
              message: res.msg,
            });
            this.$refs.payLayer.fail("");
          }, 2000);

        }
      })
    },
    handleClose() {
      this.show_pay = false;
    },
    handleForget() {
      this.$message.info({
        title: "Redefinir senha de saque",
        message: "Entre em contato com o atendimento ao cliente da plataforma para resolver o problema de redefinição da senha de saque.",
        duration: 5000
      })
    },
    doCopy(val) {
      let _this = this;
      this.$copyText(String(val)).then(
        function (e) {
          _this.$toast({
            background: "#07c160",
            message: _this.$t("复制成功"),
          });
        },
        function (e) {
          // console.log(e);
        }
      );
    },
    //提现
    submit() {

      if (this.need_bet > 0) {
        this.$message({
          title: "Aviso gentil",
          message: "Você ainda precisa apostar R$" + this.need_bet + " para poder sacar"
        });
        return false;
      }
      //没有可提现的金额
      if (this.able_money <= 0) {
        this.$toast({
          background: "#a244aa",
          message: this.$t("当前可提现金额为0"),
          duration: 3000,
        });
        return false;
      }
      //提现金额验证
      let amount_reg = /^[1-9][0-9]*([.][0-9]{1,2})?$/;
      if (!amount_reg.test(this.money)) {
        this.$toast({
          background: "#a244aa",
          message: this.$t("提现金额不正确"),
          duration: 3000,
        });
        return false;
      }
      //提现金额 大于可提现金额
      if (Number(this.money) > Number(this.able_money)) {
        this.$toast({

          background: "#a244aa",
          message: this.$t("提现金额大于可提现金额"),
          duration: 3000,
        });
        return false;
      }

      if (Number(this.money) < Number(this.min_withdraw_amount)) {
        this.$toast({
          background: "#a244aa",
          message: this.$t("提现金额小于最低提现金额"),
          duration: 3000,
        });
        return false;
      }

      //验证电话号码
      let phone_reg = /^\d{9,}$/;
      if (!phone_reg.test(this.phone_number)) {
        this.$toast({
          background: "#a244aa",
          message: this.$t("手机号码不正确"),
          duration: 3000,
        });
        return false;
      }

      console.log("123123123")
      //验证CPF
      if (this.cpf.length < 9 || this.chave_pix.length > 11) {
        this.$toast({
          background: "#a244aa",
          message: this.$t("CPF不正确"),
          duration: 3000,
        });
        return false;
      }

      //终于通过验证了

      this.show_pay = true;

    },
  },
};
</script>


<style lang="less" scoped>
@import "../../assets/css/variables.less";


.flex-row {
  display: flex;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.align-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-center {
  justify-content: center;
}

.vantTabs {
  :deep(.van-sticky) {
    width: 100%;
    max-width: @maxWidth;
    // left: 50%;
    // transform: translateX(-50%);
  }

  :deep(.van-tabs__wrap) {
    height: 0.88rem;

    .van-tabs__nav {
      padding-left: 0;
      padding-right: 0;
      background-color: @secondary-color;
    }

    .van-tab {
      padding: 0 0.2rem;

      .van-tab__text {
        font-size: 0.32rem;
      }

      &.van-tab--active {
        span {
          color: @rechargeColor;
        }
      }
    }

    .van-tabs__line {
      background-color: @rechargeColor;
    }
  }
}

/deep/ .van-tabs__nav {
  padding-left: 0;
  padding-right: 0;
  background-color: @secondary-color;
}

.recharge-one {
  box-sizing: border-box;
  width: 90%;
  // margin: 0 auto 0.3rem auto;
  margin: 0 auto;
  border-radius: 8px;
  color: @textcolor1;
  overflow: hidden;
  position: relative;
  //border: 1px solid #895DB3;
  background: @primary-color;
  padding: .5rem .5rem;
  font-size: 0.3rem;
}

.order-status {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: .2rem;
  // border-bottom: thin solid #e5e5e5;

}

.money3 {
  width: 95%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  color: @textcolorf;
  align-items: center;
}

.status {
  // width: 60px;
  padding: 0 15px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  //background: linear-gradient(to right, rgb(166, 0, 146), rgb(97, 17, 207));

}

.unpay,
.unpay1,
.unpay2,
.unpay3,
.unpay4 {
  // width: 60px;
  padding: 0 15px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  color: #fc661e;
  //background:  linear-gradient(90deg, #3FBBFE 0%, #A541FF 100%);
}

.left_div {
  display: flex;
  align-items: center;
  border-bottom: 0.01rem solid @bodercolor;
  background-color: @secondary-color;

  .left {
    margin-left: 0.3rem;
    margin-top: 0.2rem;

    svg {
      fill: @textcolor1;
    }
  }
}

.myteam-bg {
  width: 100%;
  height: 3.0rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}

.cantc {
  background-color: rgb(22, 22, 19) !important;
  font-weight: 700;
}

.base-header {
  position: relative;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 92%;
  margin: 0 auto 0.2rem auto;
  border-radius: .2rem;
  overflow: hidden;
  z-index: 1;
  border: thin solid #fbd497;
  box-sizing: border-box;
  padding: 5px 5px;

}

.big_tit {
  font-size: 0.35rem;
  text-align: center;
  width: 49%;
  height: 0.7rem;
  line-height: 0.7rem;
  color: #fff;
  border-radius: .1rem;
}

.is-active {
  color: #73634e;
  background-color: #fbd497;
}


.fee {
  color: #fff;
  margin-top: 0.2rem;

}

.amount-input {
  height: 0.8rem;
  width: 100%;
  border: none;
  margin-top: 10px;
  font-size: 14px;
  color: #fff;
  text-indent: 10px;
  border-radius: 5px;
  background: transparent;
  font-weight: 700;
  background-color: @third-color;
  //box-sizing: border-box;
}


.amount-input::placeholder {
  font-size: 0.33rem;
  color: @textcolor1;

}

.enther {
  width: 92%;
  margin: 15px auto 10px auto;
  box-sizing: border-box;
}

.endes {
  color: @textcolor1;
  font-size: 0.32rem;
  margin: 0;
}

.desc-num {
  margin-left: 0.1rem;
  color: #febe06;
  font-size: 0.35rem;
  font-weight: 700;
}

.desc-ab {
  text-align: left;
  box-sizing: border-box;
  color: @textcolor1;
}

.left-ab {
  width: 100%;
  height: 30px;
  color: #333;
  display: flex;
  align-items: center;
}

.right-ab {
  width: 100%;
  height: 30px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.ablewd {
  // width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0.2rem;
  box-sizing: border-box;
  border-bottom: 0.01rem solid @bodercolor;
  background-color: @secondary-color;
}

.free-count {
  color: #989da6;
}

.basic_btn {
  background: #FFF;
  margin: 15px auto 0;
  background-size: 100%;
  color: #132816;
  font-weight: 700;

}

.withdraw_wrap {
  width: 100%;
  height: 100vh;
  background-color: @activityColor;
  box-sizing: border-box;
}

.sbtn {
  margin: 30px auto 0 auto;
  width: 92%;
  border-radius: .2rem;
  font-size: 0.35rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  color: #fff;
  background-color: @ButtonColor;
}

.module {
  height: calc(100vh - 34px);
}

.top_module {
  background-color: @secondary-color;
  padding: 10px 20px 10px 10px;
  border-radius: 8px;
  width: 95%;
  box-sizing: border-box;
  margin: 10px auto;
  font-size: 12px;
  color: @anttextcolor;

  span {
    margin-left: 8px;
  }

  .icon {
    font-size: 16px;
  }
}

.bottom_module {
  background-color: @secondary-color;
  border-radius: 8px 8px 0 0;
  padding: 10px;
  font-size: 12px;
  flex: 1;

  .module_item {
    padding: 4px 10px;
    border-radius: 4px;
    border: 1px solid @bodercolor;
    color: @anttextcolor;
    margin-bottom: 10px;
  }

  .left_icon {
    width: 25px;
    height: 25px;
  }

  .left_name {
    line-height: 25px;
    margin-left: 10px;
  }
}

.select_items {
  display: flex;
  justify-content: space-between;
  padding-top: 0.2rem;
  padding-bottom: 0.4rem;
  padding-left: 0.5rem;
}

.flex_select {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

select {
  height: 0.7rem;
  border: 0.01rem solid @bodercolor;
  // padding-left: 0.4rem;
  // margin-left: 0.3rem;
  padding: .2rem;
  padding-top: .1rem;
  font-size: 0.26rem;
  color: @popupTextColor;
}

.bonus {
  color: @popupTextColor;
  margin-right: 0.3rem;
  font-size: 0.35rem;
  margin-top: 0.13rem;
  display: flex;
  align-items: center;

  span {
    color: @rechargeColor !important;
  }
}

select {
  border-radius: 0.5rem;
  color: @textcolor1;
  background-color: @secondary-color;
}

.wdAble {
  margin-left: 0.2rem;

  .spin {
    animation: spin 1.5s linear infinite;
  }
}

@keyframes spin {
  0% {
    transform: rotateZ(0);
  }

  100% {
    transform: rotateZ(360deg);
  }
}

.rmoney {
  color: @ButtonColor !important;
  border-bottom: 0.01rem solid @ButtonColor;
}

.wdAble svg {
  fill: @ButtonColor;
}
</style>
